import ConsultaAvancadaService from "@/services/ConsultaAvancadaService";

export const consultaAvancada = {
  namespaced: true,
  state: {
    consultaAvancada: {},
  },
  actions: {
    getConsultaAvancada({ commit }, payload) {
      return ConsultaAvancadaService.GetConsultaAvancada(payload).then(
        (consultaAvancada) => {
          return Promise.resolve(consultaAvancada);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postConsultaAvancada({ commit }, payload) {
      return ConsultaAvancadaService.PostConsultaAvancada(payload).then(
        (consultaAvancada) => {
          return Promise.resolve(consultaAvancada);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putConsultaAvancada({ commit }, payload) {
      return ConsultaAvancadaService.PutConsultaAvancada(payload).then(
        (consultaAvancada) => {
          return Promise.resolve(consultaAvancada);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteConsultaAvancada({ commit }, payload) {
      return ConsultaAvancadaService.DeleteConsultaAvancada(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getConsultaAvancadaOData({ commit }, payload) {
      return ConsultaAvancadaService.GetConsultaAvancadaOData(payload).then(
        (consultaAvancada) => {
          return Promise.resolve(consultaAvancada);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default consultaAvancada;
